// 📌 Mapeo de nombres de variables entre el Frontend y el Backend
const frontendToBackendMap = {
    "fechaConsulta": "fecha_consulta",
    "tipoInterrogatorio": "tipo_interrogatorio",
    "padecimientoActual": "padecimiento_actual",
    "diagnosticos": "diagnosticos",
    "pronostico": "pronostico", //usa el mismo para consultas y para historia clinica
    "medicamentos": "medicamentos",
    "planTratamiento": "plan_tratamiento",
    "indicacionesAdicionales": "indicaciones_adicionales",
    "proximaCita": "proxima_cita",

    // Exploración Física
    "exploracionFisica.signosVitales.presionArterial": "presion_arterial",
    "exploracionFisica.signosVitales.frecuenciaCardiaca": "frecuencia_cardiaca",
    "exploracionFisica.signosVitales.frecuenciaRespiratoria": "frecuencia_respiratoria",
    "exploracionFisica.signosVitales.temperatura": "temperatura",
    "exploracionFisica.signosVitales.saturacionOxigeno": "saturacion_oxigeno",
    "exploracionFisica.peso": "peso",
    "exploracionFisica.altura": "altura",
    "exploracionFisica.otros": "exploracion_otros",

    // Antecedentes Heredofamiliares
    "antecedentes.heredoFamiliares.madre": "antecedentes_madre",
    "antecedentes.heredoFamiliares.padre": "antecedentes_padre",
    "antecedentes.heredoFamiliares.hermanos": "antecedentes_hermanos",
    "antecedentes.heredoFamiliares.abuelos": "antecedentes_abuelos",
    "antecedentes.heredoFamiliares.otros": "antecedentes_otros",

    // Antecedentes Personales No Patológicos
    "antecedentes.personalesNoPatologicos.Origen": "origen",
    "antecedentes.personalesNoPatologicos.ocupacion": "ocupacion",
    "antecedentes.personalesNoPatologicos.escolaridad": "escolaridad",
    "antecedentes.personalesNoPatologicos.religion": "religion",
    "antecedentes.personalesNoPatologicos.mascotas": "mascotas",
    "antecedentes.personalesNoPatologicos.viajes": "viajes",
    "antecedentes.personalesNoPatologicos.alimentacion": "alimentacion",
    "antecedentes.personalesNoPatologicos.vivienda": "vivienda",
    "antecedentes.personalesNoPatologicos.otros": "otros_no_patologicos",

    // Antecedentes Personales Patológicos
    "antecedentes.personalesPatologicos.ECD": "ecd",
    "antecedentes.personalesPatologicos.quirurgicos": "quirurgicos",
    "antecedentes.personalesPatologicos.traumaticos": "traumaticos",
    "antecedentes.personalesPatologicos.hospitalizaciones": "hospitalizaciones",
    "antecedentes.personalesPatologicos.infectocontagiosos": "infectocontagiosos",
    "antecedentes.personalesPatologicos.alergias": "alergias",
    "antecedentes.personalesPatologicos.transfusionales": "transfusionales",
    "antecedentes.personalesPatologicos.exantematicos": "exantematicos",
    "antecedentes.personalesPatologicos.alcohol": "alcohol",
    "antecedentes.personalesPatologicos.tabaco": "tabaco",
    "antecedentes.personalesPatologicos.toxicomanias": "toxicomanias",
    "antecedentes.personalesPatologicos.vacunacion": "vacunacion",
    "antecedentes.personalesPatologicos.ginecoObstetricosAndrologicos": "gineco_obstetricos_andrologicos",
    "antecedentes.personalesPatologicos.hemotipo": "hemotipo",
    "antecedentes.personalesPatologicos.otros": "otros_patologicos",
    
    // ===== Historia Clínica – Core nuevos (top-level en front) =====
  "grupo_etnico": "grupo_etnico",
  "piel_anexos": "piel_anexos",
  "sistema_nervioso": "sistema_nervioso",
  "sistema_cardiovascular": "sistema_cardiovascular",
  "sistema_respiratorio": "sistema_respiratorio",
  "sistema_digestivo": "sistema_digestivo",
  "sistema_genitourinario": "sistema_genitourinario",
  "sistema_musculoesqueletico": "sistema_musculoesqueletico",
  "sistema_endocrino": "sistema_endocrino",
  "sistema_hematologico": "sistema_hematologico",
  "laboratorios_texto": "laboratorios_texto",
  "imc": "imc",
  "categoria_imc": "categoria_imc",

    //Consultas
    "fechaConsulta": "fecha_consulta",
    "motivo": "motivo",
    "evolucion": "evolucion",
    "diagnostico": "diagnosticos",

    "tratamiento": "plan_tratamiento",
    "indicacionesAdicionales": "indicaciones_adicionales",
    "exploracion_otros": "exploracion_otros",
    "laboratorios": "laboratorios"

};

// 📌 Función para convertir datos del Frontend al Backend
// 📌 Función para convertir datos del Frontend al Backend
export const mapFrontendToBackend = (data, pacienteId) => {
    let mappedData = {};

    Object.keys(data).forEach((key) => {
                   // 🚫 No queremos enviar este control auxiliar del front
    if (key === "grupo_etnico_select") return;
    if (key === "signosVitales") return;

        if (frontendToBackendMap[key]) {
            mappedData[frontendToBackendMap[key]] = data[key] || null; // ✅ Evita valores vacíos
        } else if (key === "exploracionFisica" && typeof data[key] === "object") {
            const sv = data[key].signosVitales || {};
            const peso = data[key].peso;
            const altura = data[key].altura;
            const otros = data[key].otros;
            const circunferenciaCintura = data[key].circunferenciaCintura;

            // Mapear solo si alguno tiene contenido
            const hayDatosExploracion = [
                sv.presionArterial, sv.frecuenciaCardiaca, sv.frecuenciaRespiratoria,
                sv.temperatura, sv.saturacionOxigeno, sv.sistolica, sv.diastolica,
                sv.glucemia, sv.tipoMedicion, sv.resultadoObtenidoaTravesde,
                circunferenciaCintura,peso, altura, otros
            ].some(val => val !== "" && val !== null && val !== undefined);

            if (hayDatosExploracion) {
                mappedData["presion_arterial"] = sv.presionArterial || null;
                mappedData["sistolica"] = sv.sistolica !== "" ? parseInt(sv.sistolica) : null;
                mappedData["diastolica"] = sv.diastolica !== "" ? parseInt(sv.diastolica) : null;
                mappedData["frecuencia_cardiaca"] = sv.frecuenciaCardiaca !== "" ? parseInt(sv.frecuenciaCardiaca) : null;
                mappedData["frecuencia_respiratoria"] = sv.frecuenciaRespiratoria !== "" ? parseInt(sv.frecuenciaRespiratoria) : null;
                mappedData["temperatura"] = sv.temperatura !== "" ? parseFloat(sv.temperatura) : null;
                mappedData["saturacion_oxigeno"] = sv.saturacionOxigeno !== "" ? parseFloat(sv.saturacionOxigeno) : null;
                mappedData["circunferenciaCintura"] = circunferenciaCintura != null && circunferenciaCintura !== "" ? parseInt(circunferenciaCintura) : undefined;
                mappedData["glucemia"] = sv.glucemia !== "" ? parseInt(sv.glucemia) : null;
                mappedData["tipoMedicion"] = sv.tipoMedicion !== "" ? parseInt(sv.tipoMedicion) : null;
                mappedData["resultadoObtenidoaTravesde"] = sv.resultadoObtenidoaTravesde !== "" ? parseInt(sv.resultadoObtenidoaTravesde) : null;
                mappedData["peso"] = peso != null && peso !== "" ? parseFloat(peso) : undefined;
                mappedData["altura"] = altura != null && altura !== "" ? parseFloat(altura) : undefined;
                mappedData["exploracion_otros"] = otros || null;
            }
        } else if (key === "antecedentes" && typeof data[key] === "object") {
            mappedData["antecedentes_madre"] = data[key].heredoFamiliares?.madre || "";
            mappedData["antecedentes_padre"] = data[key].heredoFamiliares?.padre || "";
            mappedData["antecedentes_hermanos"] = data[key].heredoFamiliares?.hermanos || "";
            mappedData["antecedentes_abuelos"] = data[key].heredoFamiliares?.abuelos || "";
            mappedData["antecedentes_otros"] = data[key].heredoFamiliares?.otros || "";

            mappedData["origen"] = data[key].personalesNoPatologicos?.Origen || "";
            mappedData["ocupacion"] = data[key].personalesNoPatologicos?.ocupacion || "";
            mappedData["escolaridad"] = data[key].personalesNoPatologicos?.escolaridad || "";
            mappedData["religion"] = data[key].personalesNoPatologicos?.religion || "";
            mappedData["mascotas"] = data[key].personalesNoPatologicos?.mascotas || "";
            mappedData["viajes"] = data[key].personalesNoPatologicos?.viajes || "";
            mappedData["alimentacion"] = data[key].personalesNoPatologicos?.alimentacion || "";
            mappedData["vivienda"] = data[key].personalesNoPatologicos?.vivienda || "";
            mappedData["otros_no_patologicos"] = data[key].personalesNoPatologicos?.otros || "";

            mappedData["ecd"] = data[key].personalesPatologicos?.ECD || "";
            mappedData["quirurgicos"] = data[key].personalesPatologicos?.quirurgicos || "";
            mappedData["traumaticos"] = data[key].personalesPatologicos?.traumaticos || "";
            mappedData["hospitalizaciones"] = data[key].personalesPatologicos?.hospitalizaciones || "";
            mappedData["infectocontagiosos"] = data[key].personalesPatologicos?.infectocontagiosos || "";
            mappedData["alergias"] = data[key].personalesPatologicos?.alergias || "";
            mappedData["transfusionales"] = data[key].personalesPatologicos?.transfusionales || "";
            mappedData["exantematicos"] = data[key].personalesPatologicos?.exantematicos || "";
            mappedData["alcohol"] = data[key].personalesPatologicos?.alcohol || "";
            mappedData["tabaco"] = data[key].personalesPatologicos?.tabaco || "";
            mappedData["toxicomanias"] = data[key].personalesPatologicos?.toxicomanias || "";
            mappedData["vacunacion"] = data[key].personalesPatologicos?.vacunacion || "";
            mappedData["gineco_obstetricos_andrologicos"] = data[key].personalesPatologicos?.ginecoObstetricosAndrologicos || "";
            mappedData["hemotipo"] = data[key].personalesPatologicos?.hemotipo || "";
            mappedData["otros_patologicos"] = data[key].personalesPatologicos?.otros || "";
        } else {
            mappedData[key] = data[key];
        }
    });

    // ✅ Asegurar que `paciente_id` siempre se incluya
    if (pacienteId && !data.id) {
        mappedData["paciente_id"] = pacienteId;
    } 

    // 🩺 Compatibilidad con formato de signosVitales directo (ConsultaSeguimiento)
    if (data.signosVitales && typeof data.signosVitales === "object") {
        const sv = data.signosVitales;

        mappedData["temperatura"] = sv.temperatura !== "" ? parseFloat(sv.temperatura) : null;
        mappedData["presion_arterial"] = sv.presionArterial || null;
        mappedData["sistolica"] = sv.sistolica !== "" ? parseInt(sv.sistolica) : null;
        mappedData["diastolica"] = sv.diastolica !== "" ? parseInt(sv.diastolica) : null;
        mappedData["frecuencia_cardiaca"] = sv.frecuenciaCardiaca !== "" ? parseInt(sv.frecuenciaCardiaca) : null;
        mappedData["frecuencia_respiratoria"] = sv.frecuenciaRespiratoria !== "" ? parseInt(sv.frecuenciaRespiratoria) : null;
        mappedData["saturacion_oxigeno"] = sv.saturacionOxigeno !== "" ? parseFloat(sv.saturacionOxigeno) : null;
        mappedData["circunferenciaCintura"] = sv.circunferenciaCintura != null && sv.circunferenciaCintura !== "" ? parseInt(sv.circunferenciaCintura) : undefined;
        mappedData["glucemia"] = sv.glucemia !== "" ? parseInt(sv.glucemia) : null;
        mappedData["tipoMedicion"] = sv.tipoMedicion !== "" ? parseInt(sv.tipoMedicion) : null;
        mappedData["resultadoObtenidoaTravesde"] = sv.resultadoObtenidoaTravesde !== "" ? parseInt(sv.resultadoObtenidoaTravesde) : null;
        mappedData["peso"] = sv.peso !== "" ? parseFloat(sv.peso) : null;
        mappedData["altura"] = sv.altura !== "" ? parseFloat(sv.altura) : null;
    }

    return mappedData;
};

// 📌 Función para convertir datos del Backend al Frontend
export const mapBackendToFrontend = (data) => {
    let mappedData = {};
    const backendToFrontendMap = Object.fromEntries(Object.entries(frontendToBackendMap).map(([key, value]) => [value, key]));
    Object.keys(data).forEach((key) => {
        mappedData[backendToFrontendMap[key] || key] = data[key];
    });
    return mappedData;
};
